module.exports = {

    save:      'Guardar',
    saved:     'Guardado',
    close:     'Cerrar',
    prev:      'Anterior',
    next:      'Siguiente',
    cancel:    'Cancelar',
    back:      'Anterior',
    thanks:    'Gracias!',
    send:      'Enviar',
    show_less: 'Mostrar menos',
    show_more: 'Mostrar más',
    perfect:   '¡Perfecto!',
    awesome:   '¡Genial!',
    hello_im:   'hola, soy {0}',
    hello:      'Hola',

    labels : {
        user_name:       'Tu nombre',
        user_email:      'Tu email',
        user_phone:      'Tu teléfono',
        comments:        'Comentarios adicionales',
        date:            'Selecciona una fecha',
        budget_from:     'Desde',
        budget_to:       'a',
        amount:          'Total',
        currency:        'Moneda',
        selection:       'Tu selección',
        choice_one:      'Selecciona uno',
        choice_city:     'Selecciona una ciudad',
        choice_event:    'Selecciona un evento',
        days_count:      '{count} día | {count} días',
        days_more:       'más de {count} día | más de {count} dias',
        day_x:           'Día {0}',
        total:           'Total',
        hostesses_count: '{count} azafata | {count} azafatas',
        hostesses_more:  'más de {count} azafata | más de {count} azafatas',
        guests:          '{count} invitado | {count} invitados',
        services:        '{count} servicio | {count} servicios',
        period:          '{count} período | {count} períodos',
        meals:           '{count} comida | {count} comidas',
        city:            'Ciudad',
        web:             'Página Web',
        dates:           'Fechas'
    },

    terms_label:       'He leído y aceptado {0}',
    terms_link_label:  'Política de Privacidad',

    errors : {

        area      : '¿Qué superficie tiene el stand?',
        user_name : 'El campo nombre es obligatorio',
        user_email: 'Se requiere un email valido',
        user_phone: 'El campo teléfono es obligatorio',
        estimate:   'El presupuesto es requerido',
    },

    rq : {

        stands : {


            labels : {
                city: 'Ciudad donde necesitas el Stand',
                event: '¿En qué feria expones?',
                size: 'Tamaño del stand',
                price_rank:       'Rango de precios',
                price_rank_help : 'Para hacer una correcta selección de materiales en el diseño de tu stand indícanos por favor en qué rango de precios quieres que trabajemos.',
            },

            thanks : {
                title : '¡Gracias!',
                text  : 'Le enviaremos en 48h una selección de las mejores propuestas',
                text_alt_1: 'Según nuestros datos el precio medio de un stand de {0} en {1} está en torno {2}.',
                text_alt_2: 'Una vez tengas el espacio confirmado en la feria no dudes en contactarnos de nuevo si necesitas un diseño personalizado para la misma.',
            },

            options_has_design : {

                0 : 'Diseño + Construcción',
                1 : 'Sólo construcción',
                2 : 'Otros servicios'
            },

            page_start_title:     'Solicitud de Stand',
            page_start_subtitle : 'Características',
            page_start_options_has_design :{

                0: 'Necesito el diseño del stand y su construcción y montaje',
                1: 'Ya cuento con un diseño de stand y sólo necesito su construcción y montaje',
                2: 'Otros',
            },

            page_user_title:      'Tus datos de contacto',
            page_user_subtitle:   '',

            page_price_title:     'Rango de precios',
            page_price_subtitle : '',

            page_space_title:    '¿Tienes ya confirmado el espacio en la feria?',
            page_space_subtitle: '',
            page_space_options : {

                0: 'No, todavía estoy evaluando si exponer y me interesa los costes de un stand',
                1: 'Sí, ya tengo el espacio confirmado y la ubicación',
            },

            page_type_title    : 'Indícanos que tipo de stand estás buscando',
            page_type_subtitle : '',
            page_type_options : {
                design:  'Stand de diseño',
                modular: 'Stand Modular',
                mixed :  'Stand Mixto',
                display: 'Stand Display',
                none:     'Todavía no lo sé'
            },

            page_properties_title:     '¿Qué elementos o espacios necesitas en tu stand?',
            page_properties_subtitle : 'Puedes seleccionar tantos como necesites',
            page_properties_options: {
                counter:            'Mostrador',
                furniture:          'Mobiliario',
                multimedia:         'Alquiler multimedia',
                closedMeetingRoom:  'Sala de reuniones cerrada',
                openMeetingRoom:    'Sala de reuniones abierta',
                spaceStorage:       'Espacio almacenaje',
                cateringArea:       'Área de catering',
                hangingElements:    'Elementos colgantes',
            },

            page_staff_title:               '¿Cuántos empleados estarán en el stand durante el evento?',
            page_staff_subtitle:            'Especifique el número de empleados, la posición que tienen, que van a estar en el stand. Esta información es útil para diseñar el stand. Ejemplo: gerente + 3 vendedores + azafatas',

            page_price_relevance_title :    '¿Qué tan relevante es el precio en su decisión de compra?',
            page_price_relevance_subtitle : 'El precio y el diseño son dos caras de la misma moneda, con un presupuesto mayor, más inversión en el diseño y los materiales para construir el stand. Cuéntanos cuán importante es cada uno de estos aspectos.',
            page_price_relevance_options  : {

                label1 : 'Relevancia:',
                label2 : 'Mínima',
                label3 : 'Baja',
                label4 : 'Media',
                label5 : 'Alta',
                label6 : 'Máxima',
                label7 : 'Precio',
                label8 : 'Diseño',
            },

            page_price_max_title:    'Presupuesto y moneda',
            page_price_max_subtitle: 'Seleccionó el precio como el aspecto más importante. ¿Cuál es el presupuesto máximo?',

            page_upload_alt_title:    '¿Desea adjuntar algún diseño, idea o concepto de cómo debería ser su stand? Esto nos ayudaría a comprender mejor qué tiene en mente.',
            page_upload_alt_subtitle: '',

        },

        hostesses : {


            thanks : {
                title : '¡Gracias!',
                text  : 'Envíanos por favor tu CV a CV.hostesses@neventum.com y se lo haremos llegar a nuestras empresas de azafatas asociadas',
            },

            create : {

                1 : {
                    title:       'Solicitud de Azafatas',
                    subtitle:    'En que ciudad y evento necesitas el servicio',
                    label1:      '¿En qué ciudad necesitas azafatas?',
                    label2:      'Indica el nombre del evento',
                    placeholder: 'Escribe o selecciona un elemento',
                },
                2 : {
                    title         : '¿Nos puedes confirmar esta información, por favor?',
                    label1        : 'Confirmar ciudad',
                    label2        : 'Confirmar fecha inicio',
                },
                3 : {
                    'title'         : 'Solicitud de Azafatas',
                    'subtitle'      : 'Tus datos de contacto',
                },
                4 : {
                    'title'         : 'Para darte un mejor servicios indícanos, por favor, cual es tu perfil.',
                    'label1'        : 'Soy un <b>Cliente</b> que solicita un servicio de azafatas',
                    'label2'        : 'Soy una <b>Agencia</b> que requiero azafatas para un cliente',
                    'label3'        : 'Soy una <b>Azafata</b> buscando trabajo que quiere enviar su CV',
                },
                5 : {
                    'title'         : 'Indica cuantas azafatas necesitas y durante cuantos días las requieres.',
                    'label1'        : 'Azafatas requeridas',
                    'label2'        : 'Días requeridos',
                    'label3'        : 'Lamentablemente no hemos encontrado el evento en nuestra base de datos, por favor indícanos en que fecha empieza',
                },
                6 : {
                    'title'         : 'Cuantas horas necesitas el servicio de azafatas cada día',
                    'option1'       : '1 hora',
                    'option2'       : '{0} horas',
                    'option3'       : 'Más de 8 horas',
                },
                7 : {
                    'title'         : 'Aproximadamente cuantas horas necesitas el servicio de azafatas cada día',
                    'option1'       : '1 hora',
                    'option2'       : '{0} horas',
                    'option3'       : 'más de 8 horas',
                },
                8 : {
                    'title'         : '¿Qué tareas deberán desempeñar las azafatas?',
                    'body'          : 'Ejemplo: necesito azafatas de imagen que permanezcan en el mostrador del stand y que eventualmente repartan flyers por la feria y una azafata bilingüe que nos ayude con gestiones comerciales, ...',
                },
                9 : {
                    'title'         : 'Idiomas requeridos',
                    'body'          : 'Selecciona y/o indica los idiomas requeridos',
                    'label1'        : 'Castellano',
                    'label2'        : 'Italiano',
                    'label3'        : 'Francés',
                    'label4'        : 'Inglés',
                    'label5'        : 'Alemán',
                    'label6'        : 'Portugués',
                    'label7'        : 'Otros',
                },

                'errors' : {
                    'city'              : 'Selecciona una ciudad',
                    'event'             : 'Selecciona un evento',
                    'userName'          : 'Debes introducir el nombre de usuario',
                    'userEmail'         : 'Debes introducir el email',
                    'userPhone'         : 'Debes introducir el número de teléfono',
                    'invalidEmail'      : 'Debes introducir un email válido',
                    'profile'           : 'Seleccióna un perfil',
                    'countHostesses'    : '¿Cuántas azafatas vas a necesitar?',
                    'countDays'         : '¿Cuántos días vas a estar?',
                    'deadline'          : 'Introduce la fecha del evento',
                    'days'              : 'Completa la jornada de todos los días',
                    'hoursAvg'          : 'Completa las horas de jornada',
                    'tasks'             : '¿Qué tarea tendran las azafatas?',
                    'langs'             : '¿Qué idiomas necesitan saber las azafatas?',
                    'otherLang'        : 'Introduce otros idiomas',
                }
            }
        },

        catering : {

            thanks : {
                title         : '¡Gracias!'
            },

            guests: 'Invitados',

            1 : {
                title         : 'Solicitud de Catering',
                subtitle      : 'En que ciudad y evento necesitas el servicio',
                label1        : '¿En qué ciudad necesitas un catering?',
                label2        : 'Indica el nombre del evento',
                placeholder   : 'Escribe o selecciona un elemento',
            },
            2 : {
                title         : 'Solicitud de Azafatas',
                subtitle      : 'Tus datos de contacto',
                placeholder1  : 'Tu nombre',
                placeholder2  : 'Tu email',
                placeholder3  : 'Tu teléfono',
            },
            3 : {
                title:      'Indica durante cuantos días necesitas el servicio de catering',
                label_days: 'Días requeridos',
                label_date: 'Lamentablemente no hemos encontrado el evento en nuestra base de datos, por favor indícanos en que fecha empieza',

            },
            4 : {
                title         : '¿Cuántos invitados esperas tener?',
            },

            5 : {
                title: '¿Cuántos invitados esperas tener por día?',
            },
            6 : {
                title         : '¿Aproximadamente cuántos invitados esperas tener cada día?',
            },
            7 : {
                title         : '¿Que tipo de servicio estás buscando ?',
                title2        : '¿En que horario necesitas el catering ?',
                label1        : 'Buffet durante evento',
                label2        : 'CoffeeBreak',
                label3        : 'Platos principales',
                label4        : 'Todo el día',
                label5        : 'Desayuno',
                label6        : 'Comida',
                label7        : 'Cena',
            },
            8 : {
                title         : '¿Qué servicios debe incluir el presupuesto ?',
                label1        : 'Camareros',
                label2        : 'Refrescos y cafés',
                label3        : 'Bebidas alcohólicas',
                label4        : 'Comida',
                label5        : 'Mobiliario',
                label6        : 'Cubiertos, vasos, ...',
            },
            9 : {
                title         : 'Presupuesto',
                label1        : 'Presupuesto por invitado',
                label2        : 'Presupuesto global del evento',
                text1         : 'Indícanos por favor el presupuesto máximo global que has considerado para presentarte la mejor opción de catering en ese rango de precios',
                text2         : 'Indícanos por favor el presupuesto máximo por invitado que has considerado para presentarte la mejor opción de catering en ese rango de precios',
            },
            10 : {
                title         : '¿Quieres añadir algo más?',
                subtitle      : 'Si se requieren alimentos especiales, intolerancias, algún tipo de menú, ....'
            },

            labels : {

                service   : {
                    buffet        : 'Buffet',
                    coffeeBreak   : 'Descanso',
                    mainDishes    : 'Platos principales',
                },
                period    : {
                    allday        : 'Durante todo el evento',
                    breakfast     : 'Desayuno',
                    lunch         : 'Comida',
                    dinner        : 'Cena',
                },
                budgetType : {
                    byGuest : 'Presupuesto por invitado',
                    global  : 'Presupuesto global'
                }
            },

            errors : {
                city:         'Selecciona una ciudad',
                event:        'Selecciona un evento',
                userName:     'Debes introducir el nombre de usuario',
                userEmail:    'Debes introducir el email',
                userPhone:    'Debes introducir el número de teléfono',
                invalidEmail: 'Debes introducir un email valido',
                days:         'Debes seleccionar cuantos días son requeridos',
                deadline:     'Introduce la fecha del evento',
                guests:       'Debes introducir el nombre de invitados',
                daysResume:   'Debes introducir el número de invitados por día',
                guestsAvg:    'Debes introducir el nombre de invitados',
                period:       'Selecciona un horario',
                service:      'Selecciona un servicio',
                budgetType:   'Selecciona una opción para el presupuesto',
                budget:       'Introduce  el presupuesto máximo',
                budgetFormat: 'El presupuesto máximo debe ser un número entero'
            }

        }
    },

    corporation : {

        suppliers : {

            page_navbar_my_brand        : 'Mi marca:',
            page_navbar_data            : 'Data',
            page_navbar_presentation    : 'Presentación',
            page_navbar_geo             : 'Donde trabajas',
            page_navbar_stands          : 'Mis stands',
            page_navbar_office          : 'Oficina',
            page_navbar_scopes          : 'Ámbito',

            page_related_is_other       : 'Crear nueva empresa',
            page_related_is_this        : 'Esta es mi empresa',
            page_related_created_by     : 'Perfil <b>creado por {0}</b> el {1}',
            page_related_not_suggested  : 'Mi empresa no coincide con las sugerencias, quiero continuar el proceso de alta:',

            page_resolution_label_1     : 'No hagáis <b>nada</b>, lo resolveremos internamente',
            page_resolution_label_2     : '{0} seguirá llevando la marca pero <b>yo quiero permisos para actualizar el contenido, recibir leads</b>, ...',
            page_resolution_label_3     : '{0} ya no es el responsable de gestionar este contenido, <b>desde ahora yo soy la responsable</b> de dicho contenido',

            labels : {
                name                    : 'Nombre de tu empresa',
                city                    : 'Ciudad',
                sector                  : 'Sector de actividad',
                address                 : 'Dirección',
                web                     : 'Página Web',
            },

            alerts : {

                group_suppliers_text_1  : '<b>¿Es esta tu empresa?</b>',
                group_suppliers_text_2  : 'Alguien de tu empresa tiene un perfil en neventum - lo hemos detectado por el email corporativo -',
                group_suppliers_text_3  : 'Nos ha parecido una buena idea enseñartelo porqué si ibas a crear la misma empresa te ahorramos el trabajo',
                group_suppliers_text_4  : 'Si ibas a crear esa empresa dínoslo y solicita, si quieres, permisos de edición. Si era otra empresa indícalo y sigamos con el proceso de alta.',

                other_suppliers_text_1  : '<b>¿Es esta tu empresa?</b>',
                other_suppliers_text_2  : 'En base a la información que has introducido de tu marca hemos encontrado algunas marcas parecidas en neventum.',
                other_suppliers_text_3  : 'Para evitar que dupliques una marca que ya haya creado un compañero te las mostramos a continuación.',
                other_suppliers_text_4  : 'Si ibas a crear esa empresa dínoslo y solicita, si quieres, permisos de edición. Si era otra empresa indícalo y sigamos con el proceso de alta.',

               resolution_text_1        : '<b>¡Genial!</b>',
               resolution_text_2        : 'Sólo necesitamos saber quien gestionará la marca a partir de ahora: tú, tu compañero, ambos...',
               resolution_text_3        : 'Selecciona una opción a continuación.',

            },

            page_thank_send_email   : 'Le hemos enviado un email a {0} para que te añada los permisos necesarios',
            page_thank_we_wait      : 'Quedamos a la espera de vuestras noticias!',
            page_thank_will_help    : 'Voy a ayudarte con el cambio de propietario de {0}, te contactaré enseguida para empezar el proceso.'
        }
    },

    event : {

        page_related_from_to        : 'del {0} al {1}',
        page_related_is_this        : 'Reclamar Evento',
        page_related_not_suggested  : 'Mi evento no coincide con las sugerencias, quiero continuar el proceso de alta:',
        page_related_is_other       : 'No es ninguno de estas',

        page_thank_label_1          : 'Hola {0},',
        page_thank_label_2          : 'Nuestro equipo de redacción está evaluando tu solicitud para añadir este evento a tu perfil.',
        page_thank_label_3          : 'En un plazo inferior a 24h ( sin contar festivos ) lo habremos resuelto ;)',
        page_thank_label_4          : 'Te mantenemos informada y te invitamos q a que añadas otros eventos que organizas',
        page_thank_label_5          : 'Un saludo',
        page_thank_label_6          : 'neventum Editorial Staff',

        labels : {
            'sector'                : 'Sector del evento',
            'periodicity'           : 'Periodicidad del evento',
            'scope'                 : 'Alcance del evento',
            'name'                  : 'Nombre del evento'
        },

        periodicity : {
            mensual                 : 'Mensual',
            trimestral              : 'Trimestral',
            semestral               : 'Semestral',
            anual                   : 'Anual',
            bienal                  : 'Bienal',
            trienal                 : 'Trienal',
            cuatrienal              : 'Cuatrienal',
        },

        scopes : {
            local                   : 'Local',
            national                : 'Nacional',
            international           : 'Internacional',
        },

        alerts : {

            related_events_text_1 : '<b>¿Es este tu evento?</b>',
            related_events_text_2 : 'En base a la información que has introducido de tu evento hemos encontrado algunos eventos parecidos en neventum.',
            related_events_text_3 : 'Para evitar que dupliques un evento con el que ya contamos en nuestro calendario te los mostramos a continuación.',
            related_events_text_4 : 'Si ibas a crear uno de estos eventos dínoslo y solicita, si quieres, permisos de edición sobre él',

        },
    },

    reviews : {

        thanks : 'Gracias por compartirnos tu opinión',

        labels : {


            rate      : 'Tu calificación general',
            opinion   : 'Tu opinión',

            city                : 'En que ciudad se construyó el stand?',
            city_stands         : 'En que ciudad se construyó el stand?',
            city_catering       : 'En que ciudad se celebró el evento?',
            city_hostesses      : 'En que ciudad requeriste sus Azafatas?',

            worked_at           : 'Cuando te construyó el stand',
            worked_at_stands    : 'Cuando te construyó el stand',
            worked_at_catering  : 'Cuando se celebró el evento?',
            worked_at_hostesses : 'Cuando te celebró el evento?',

            name      : 'Tu nombre',
            email     : 'Tu email',
            anonymous : 'Quiero que esta opinión sea anónima, mi nombre no aparecerá ni le será comunicado al proveedor sobre el que estoy opiniando',
            accept    : 'Certifico que esta opinión se basa en mi propia experiencia y es mi opinioón genuina sobre este proveedor y que no tengo ninguna relación personal ni comercial con el mismo ni me han ofrecido ningún tipo de incentivo o pago alguno para que escribiese esta opinión. Comprendo que neventum tiene una política de tolerancia cero con las opiniones falsas.',
            submit    : 'Envia tu opinión',
        },

        help : {
            name  : 'Tu nombre no será público si nos lo indicas',
            email : 'Esta información NUNCA será pública',
        },
    },

    rate : {
        label           : 'Haz clic para puntuar',
        label_bad       : 'Pésimo',
        label_poor      : 'Malo',
        label_fair      : 'Normal',
        label_good      : 'Bueno',
        label_excellent : 'Excelente',
    },

    cookie : {
        text            : 'Las cookies recogen información en tu navegador web para ofrecerte una mejor experiencia online. En neventum utilizamos cookies, si continuas navegando consideramos que aceptas su uso.',
        label_accept    : 'Aceptar',
        label_info      : 'Más información',
    },

    session : {
        login :     'Iniciar sesión',
        register :  'Registrarse',
    },

    login : {
        title :                 'Bienvenido a neventum',
        placeholder_email :     'E-mail',
        placeholder_password :  'Contraseña',
        signin :                'Iniciar sesión',
        forget_password :       '¿Olvidaste tu contraseña?',
        register :              'No tengo una cuenta',
    },
};



// WEBPACK FOOTER //
// ./resources/js/i18n/es.js